import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";
// Convention to establish the relation between number and video type. BE only allows video type as an integer number.
export default _Object$freeze({
  YOUTUBE: {
    id: 0,
    name: 'youtube',
    beatifulName: 'YouTube'
  },
  VIMEO: {
    id: 1,
    name: 'vimeo',
    beatifulName: 'Vimeo'
  }
});